import React from "react";
import * as styles from "./Fieldset.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const Fieldset = ({ children, noStyling, className, highlighted = false, layout = {} }) => {
	const { tabsContainer } = layout;
	const fieldsetClassName = classNames(
		{
			[styles["fieldset"]]: !noStyling && !tabsContainer,
			[styles["highlighted"]]: highlighted,
			[styles["tabsContainer"]]: tabsContainer,
			[className]: !!className,
		},
		"fieldset",
	);

	return <div className={fieldsetClassName}>{children}</div>;
};

Fieldset.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
};

export default Fieldset;
